<style scoped>

.body {
  background: #f5f7f9;
  overflow: hidden;
  border-radius: 4px;
}

.content {
  background: #ffffff;
  padding: 15px;
  overflow: hidden;
  /*margin-bottom: 60px;*/
}
.left-content {
  width: 100%;
  position: fixed;
  z-index: 999;
  top: 90px;
}
.right-content {
  margin-top: 60px;
  overflow: hidden;
}
.ivu-icon {
  width: 12px;
}
</style>

<template>
  <div class="body">
    <div class="content">
      <div class="left-content" v-if="menus.length>0">
        <Menu theme="light"
              accordion
              :active-name="activeName"
              :open-names="openNames"
              ref="menu"
              mode="horizontal"
              @on-select="selectMenu">
          <template v-for="(level1, i) in menus">
            <template v-if="!level1.childMenuResources || level1.childMenuResources.length === 0">
              <MenuItem :name="level1.menuUri" :key="level1.menuName">
                {{level1.menuName}}
              </MenuItem>
            </template>
            <template v-else>
              <Submenu 
                  :key="i"
                  ref="submenu"
                  :name="level1.menuName">
                <template slot="title">
                  {{level1.menuName}}
                </template>
                <template v-for="(level2, j) in level1.childMenuResources"
                          :name="level2.menuName">
                  <template v-if="level2.childMenuResources && level2.childMenuResources.length > 0">
                    <MenuGroup :title="level2.menuName"
                              :key="level2.menuBrief">
                      <template v-for="(level3) in level2.childMenuResources">
                        <MenuItem :name="level3.menuUri"
                                  :key="level3.menuName">{{level3.menuName}}</MenuItem>
                      </template>
                    </MenuGroup>
                  </template>
                  <template v-else>
                    <MenuItem :name="level2.menuUri"
                              :key="level2.menuName">{{level2.menuName}}</MenuItem>
                  </template>
                </template>
              </Submenu>
            </template>
          </template>
        </Menu>
      </div>
      <div class="right-content" :style="menus.length==0?'margin-top:0;':''">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive"></router-view>
      </div>
    </div>
    <my-footer ref="footer"></my-footer>
  </div>
</template>
<script>
import $ from 'jquery';

import myFooter from'@/components/footer'
export default {
  data () {
    return {
      userName: '',
      personPosition: '',
      activeName: null,
      openNames: [],
      leftContentHeight: 300
    }
  },
  watch: {
    $route: {
      handler () {
        this.activeName = `/finance${this.$route.path}.html`
        this.getOpendNames()
        if (this.$refs.submenu) {
          this.$refs.submenu.forEach(v => {
            v.opened = this.openNames.indexOf(v.name) >= 0
          })
        }

        this.$nextTick(() => {
          this.$refs.menu && this.$refs.menu.updateOpened()
          this.$refs.menu && this.$refs.menu.updateActiveName()
        })
        setTimeout(() => {
          // 切换菜单后滚动选中菜单到可视区域
          try {
            let curTop = $(".ivu-menu-item-active.ivu-menu-item-selected").offset().top
            let curH = $(".ivu-menu-item-active.ivu-menu-item-selected").innerHeight()
            let boxTop = $(".left-content").offset().top
            let diff = 0
            if (curTop + curH > this.leftContentHeight + boxTop) {
              diff = curTop + curH - (this.leftContentHeight + boxTop) + 50 // 选中位置超出盒子底部  多滚动50
            } else if (curTop < boxTop) {
              diff = curTop - boxTop - 50 // 选中位置超出盒子顶部  多滚动50
            }
            $(".left-content").scrollTop($(".left-content").scrollTop() + diff)
          } catch (err) { }
        }, 350)//等待iview menu动画结束
      },
      immediate: true
    }
  },
  methods: {
    selectMenu (uri) {
      var path = uri.substring(0, uri.indexOf('.html')).replace('/finance', '');
      this.$router.push({path: path});
    },
    logout () {
      if (window.sessionStorage.user) {
        window.sessionStorage.removeItem('user');
      }
      if (window.sessionStorage.menus) {
        window.sessionStorage.removeItem('menus');
      }
      window.sessionStorage.removeItem('vuex_tabview_tabList') // 清空标签页列表缓存
      window.sessionStorage.removeItem('vuex_crm_callingCorp') // 清空crm呼叫企业
      window.sessionStorage.removeItem('vuex_crm_corpList') // 清空crm企业列表
      window.location.assign('/uaa/logout?redirect_url=/biz/login');
    },
    setHeight () {
      this.leftContentHeight = (document.documentElement.clientHeight || document.body.clientHeight) - (this.menus.length > 0 ? 280 : 220)
      var height = this.leftContentHeight-1 + "px";
      // $(".left-content").css("height", height);
      $(".right-content").css("min-height", height);

    },
    scrollEvent () {
      $(window).resize(() => {
        this.setHeight();
      });
    },
    getOpendNames () {
      // this.openNames
      // 企业账单缴费清分匹配
      // "/biz/clearing/corp/pay-bill-match.html"
      let _this = this
      get(this.menus)
      function get (list, parentName) {
        list.forEach(v => {
          if (v.childMenuResources && v.childMenuResources.length > 0) {
            get(v.childMenuResources, v.menuLevel <= 1 ? v.menuName : parentName)
          } else {
            if (v.menuUri == _this.activeName) {
              _this.openNames = [parentName]
            }
          }
        })
      }
    }
  },
  created () {
    // this.userName = JSON.parse(window.sessionStorage.user).personName;
    // this.personPosition = JSON.parse(window.sessionStorage.user).personPosition;
    this.scrollEvent();
    this.getOpendNames()
  },
  computed: {
    menus () {
      // return this.$store.state.menuList
      let menus = [
        {
          childMenuResources: null,
          fkMenuParent: null,
          fkResource: null,
          fkSystem: "SCFP_WEB_FINANCE",
          menuBrief: "0-融资查询",
          menuLevel: 1,
          menuName: "融资查询",
          menuNameEn: "1",
          menuOrder: 0,
          menuUri: '/finance/query.html',
          pkMenu: "a6018dc9-3f25-4677-b685-d52b4b236350",
          resourceType: null
        },
        {
          childMenuResources: null,
          fkMenuParent: null,
          fkResource: null,
          fkSystem: "SCFP_WEB_FINANCE",
          menuBrief: "0-开票信息管理",
          menuLevel: 1,
          menuName: "开票信息管理",
          menuNameEn: "1",
          menuOrder: 0,
          menuUri: '/finance/invoice-query.html',
          pkMenu: "a6018dc9-3f25-4677-b685-d52b4b236351",
          resourceType: null
        }
      ]
      return menus
    }
  },
  mounted () {
    this.setHeight();
  },
  components: {
    myFooter
  }

}
</script>
